// YOL HATTI — merkezi Türkçe etiketler. UI KATMANI çevirisi yapar,
// backend enum değerleri değişmez.

export const TRANSPORT_REQUEST_STATUS_TR = {
  DRAFT: "Taslak · Müşteri Onayı Bekliyor",
  OPEN: "Teklif Bekliyor",
  OFFER_ACCEPTED: "Teklif Kabul Edildi",
  AWAITING_PICKUP: "Araç/Şoför Atandı",
  PICKED_UP: "Yük Alındı",
  IN_TRANSIT: "Taşımada",
  DELIVERED: "Teslim Edildi",
  COMPLETED: "Tamamlandı",
  CANCELLED: "İptal Edildi",
  EXPIRED: "Süresi Doldu",
};

export const OFFER_STATUS_TR = {
  pending: "Bekliyor",
  accepted: "Kabul Edildi",
  rejected: "Reddedildi",
  closed: "Kapandı",
  withdrawn: "Geri Çekildi",
  cancelled: "İptal",
};

export const EMPTY_RETURN_STATUS_TR = {
  ACTIVE: "Aktif",
  CANCELLED: "İptal Edildi",
  MATCHED: "Eşleşti",
  EXPIRED: "Süresi Doldu",
};

export const HELP_REQUEST_STATUS_TR = {
  pending: "BEKLİYOR",
  accepted: "KABUL EDİLDİ",
  driver_arriving: "ŞOFÖR YOLDA",
  en_route: "YOLDA",
  arrived: "MÜŞTERİYE ULAŞILDI",
  completed: "TAMAMLANDI",
  cancelled: "İPTAL EDİLDİ",
  rejected: "REDDEDİLDİ",
};

export function roadsideStatusLabel(status) {
  if (!status) return "—";
  return HELP_REQUEST_STATUS_TR[status] || String(status).toUpperCase();
}

export function trStatusVariant(status) {
  const map = {
    DRAFT: "outline",
    OPEN: "default",
    OFFER_ACCEPTED: "default",
    AWAITING_PICKUP: "default",
    PICKED_UP: "default",
    IN_TRANSIT: "default",
    DELIVERED: "default",
    COMPLETED: "secondary",
    CANCELLED: "destructive",
    EXPIRED: "destructive",
    pending: "secondary",
    accepted: "default",
    rejected: "destructive",
    closed: "outline",
    ACTIVE: "default",
  };
  return map[status] || "secondary";
}

// Progress step index for active transport lifecycle (0..5)
export const TRANSPORT_STEPS = [
  { key: "OPEN", label: "Teklif Bekliyor" },
  { key: "OFFER_ACCEPTED", label: "Teklif Kabul" },
  { key: "AWAITING_PICKUP", label: "Alıma Gidiyor" },
  { key: "PICKED_UP", label: "Yük Alındı" },
  { key: "IN_TRANSIT", label: "Taşımada" },
  { key: "DELIVERED", label: "Teslim Edildi" },
  { key: "COMPLETED", label: "Tamamlandı" },
];

export function transportStepIndex(status) {
  const idx = TRANSPORT_STEPS.findIndex((s) => s.key === status);
  return idx >= 0 ? idx : 0;
}
